import { render, staticRenderFns } from "./cooperateListDetail.vue?vue&type=template&id=1a927630&scoped=true&"
import script from "./cooperateListDetail.vue?vue&type=script&lang=js&"
export * from "./cooperateListDetail.vue?vue&type=script&lang=js&"
import style0 from "./cooperateListDetail.vue?vue&type=style&index=0&id=1a927630&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a927630",
  null
  
)

export default component.exports